import { logout } from "./auth.js";

export const API_URL =
  process.env.REACT_APP_API_URL ||
  `${window.location.protocol}//${window.location.hostname}:3000/api`;

export async function apiFetch(path, options = {}) {
  const token = localStorage.getItem("token");
  const headers = {
    "Content-Type": "application/json",
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
  };

  const res = await fetch(`${API_URL}/${path}`, {
    headers,
    ...options,
  });

  // Handle unauthorized (401) - token expired or invalid
  if (res.status === 401) {
    logout();
    window.location.hash = "login";
    throw new Error("Sessão expirou. Por favor, faça login novamente.");
  }

  if (!res.ok) {
    const error = await res.text();
    throw new Error(error);
  }

  return res.json();
}
